module.exports = __webpack_public_path__ + "static/img/m4.0f5614b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m4.jpg
// module id = Bj+x
// module chunks = 1